import bgImage from "@/assets/testimonials-bg.png";
import chatIcon from "@/assets/icons8-whatsapp-50.png";

import testimg1 from "@/assets/test-img-1.png";
import testimg2 from "@/assets/test-img-2.png";
import testimg3 from "@/assets/test-img-3.png";
import video1 from "@/assets/video/testimonials/Prof Kotha final.mp4";
import video2 from "@/assets/video/testimonials/Nikhita.mp4";
import video3 from "@/assets/video/testimonials/Raghu I.T professional.mp4";
import video4 from "@/assets/video/testimonials/Dr.Padmaja.G.mp4";
// import video4 from "@/assets/video/testimonials/Nikhita.mp4";
import video5 from "@/assets/video/testimonials/Puneet kaur.mp4";
import { Swiper, SwiperSlide } from "swiper/react";

// import required modules
import { Navigation } from "swiper/modules";

export default function TestimonialsPage() {
  return (
    <div>
      <div
        className="relative bg-cover bg-center h-screen text-white"
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
      >
        <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
          <h1 className="text-3xl lg:text-7xl md:text-6xl font-bold text-[#78A742]">
            What Our Clients Say
          </h1>
          <p className="mt-4 text-black text-lg lg:text-2xl md:text-2xl max-w-3xl">
            Real stories from real people
          </p>
          <a
            href="https://wa.me/919892147989"
            target="_blank"
            className="fixed z-[9999] bottom-6 right-4 sm:bottom-8 sm:right-8 bg-green-600 hover:bg-green-700 text-black font-bold text-lg px-5 py-2 rounded-full flex items-center space-x-2 shadow-md"
          >
            <span>Chat Now</span>
            <img src={chatIcon} className="w-8" alt="fdd" />
          </a>
        </div>
      </div>

      <div className="bg-white py-12 px-3 lg:px-18 sm:px-20 max-w-7xl mx-auto">
        <div className="space-y-12">
          <div className="flex flex-col-reverse md:flex-row items-center gap-3 lg:gap-42">
            <div>
              <p className="text-gray-700 text-xl sm:text-xl  ">
                Uma is an extraordinary financial advisor. She is extremely
                knowledgeable and competent, with many years of experience –
                this combination allows her to give practical and sound
                guidance. Her integrity is profound, she will always do the
                right thing for me. Uma is someone I trust unconditionally.
                <br /> Perhaps most of all, Uma is an incredible financial
                advisor because she cares about me, which she shows through the
                time she takes to understand my particular situation and find
                the best options for me. She checks in with me regularly and
                helps me on all things, big and small. <br /> Thank you, Uma,
                for helping me build a secure financial foundation
              </p>
              <p className=" text-2xl mt-2 font-bold text-black">
                Archana Kalegaonkar
              </p>
            </div>
            <img
              src={testimg1}
              alt="testimonial1"
              className="w-full lg:w-80 object-cover "
            />
          </div>

          {/* Testimonial 2 */}
          <div className="flex flex-col md:flex-row items-center gap-3 lg:gap-25">
            <img
              src={testimg2}
              alt="testimonial2"
              className="w-full lg:w-80 object-cover "
            />
            <div>
              <p className="text-gray-700 text-xl sm:text-xl ">
                Uma is a very astute and erudite Financial Planner and
                investment advisor. She has always provided very useful advice
                to me on investment matters. Her inputs have benefitted me. She
                also takes abundant care to keep herself abreast of all the new
                developments in her field. These are in turn shared with clients
                like me. This enables us to stay at the forefront of all the new
                concepts in financial planning.
              </p>
              <p className="text-2xl mt-2 font-bold text-black">
                Ranjit Mathure
              </p>
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="flex flex-col-reverse md:flex-row items-center gap-3 lg:gap-25">
            <div>
              <p className="text-gray-700 text-xl sm:text-xl ">
                I'm Dr Poonam and I am a dental surgeon by profession. I have
                known Uma since more than 10 years and she has been a financial
                advisor for me since I got my first salary. Slowly and steadily
                I have learnt to save efficiently under her guidance and she is
                helping me in this journey.
                <br />
                She is very proficient in her work and knows the pulse of the
                market and I trust her completely. I am grateful to have her as
                an advisor and I hope many more can take her services.
              </p>
              <p className="text-2xl mt-2 font-bold text-black">
                Dr. Poonam Desai
              </p>
            </div>
            <img
              src={testimg3}
              alt="testimonial3"
              className="w-80 h-80 object-cover "
            />
          </div>

          {/* Testimonial 4 */}
          <div className="flex flex-col md:flex-row items-center gap-3 lg:gap-25">
            {/* <img
              src="https://i.pinimg.com/736x/1b/2e/31/1b2e314e767a957a44ed8f992c6d9098.jpg"
              alt="testimonial2"
              className="w-full lg:w-80 object-cover "
            /> */}
            <div>
              <p className="text-gray-700 text-xl sm:text-xl ">
                Oaktree and Uma came into our lives at the perfect time. As
                working professionals, my wife and I thought we were on track
                with our finances and investments, but we soon realised we
                weren’t. After meeting Uma and discussing our goals, we set
                clear milestones and started planning, saving, and investing
                with a few lifestyle changes. The journey was challenging, but
                after a year, we’ve achieved two of our three milestones and are
                planning the next ones. Thanks to Uma and Oaktree!
              </p>
              <p className="text-2xl mt-2 font-bold text-black">
                Mr and Mrs Shende
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white py-12 px-4 sm:px-8 max-w-7xl mx-auto text-center">
        <h2 className="text-3xl lg:text-5xl font-semibold text-[#78A742] mb-9 lg:mb-20">
          What our clients say
        </h2>

        {/* Video 1 */}
        <div className="flex justify-center mb-10 gap-10">
          <Swiper
            slidesPerView={1}
            spaceBetween={30}
            autoplay={{ delay: 2000 }}
            loop
            navigation={true}
            modules={[Navigation]}
            breakpoints={{
              1080: {
                slidesPerView: 3,
              },
              768: {
                slidesPerView: 2,
              },
            }}
          >
            <SwiperSlide>
              <div className="relative">
                <video
                  className="rounded-xl h-[400px] object-cover"
                  controls
                  src={video1}
                ></video>
                <p className="bg-[#92CD4D] text-black font-semibold text-xl px-18 py-3 mt-4 rounded-2xl inline-block">
                  Prof Kotha
                </p>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="text-center">
                <video
                  className="rounded-xl h-[400px] w-full object-cover"
                  controls
                  src={video3}
                ></video>
                <p className="bg-[#92CD4D] text-black font-semibold text-xl px-15 py-3 mt-4 rounded-2xl inline-block">
                  Raghu ram
                </p>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="text-center">
                <video
                  className="rounded-xl h-[400px] w-full object-cover"
                  controls
                  src={video2}
                ></video>
                <p className="bg-[#92CD4D] text-black font-semibold text-xl px-12 py-3 mt-4 rounded-2xl inline-block">
                  Nikita Dinkar
                </p>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="text-center">
                <video
                  className="rounded-xl h-[400px] w-90 sm:w-115 object-cover"
                  controls
                  src={video4}
                ></video>
                <p className="bg-[#92CD4D] text-black font-semibold text-xl px-12 py-3 mt-4 rounded-2xl inline-block">
                  Puneet kaur
                </p>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="text-center">
                <video
                  className="rounded-xl h-[400px] w-full object-cover"
                  controls
                  src={video5}
                ></video>
                <p className="bg-[#92CD4D] text-black font-semibold text-xl px-12 py-3 mt-4 rounded-2xl inline-block">
                  Puneet kaur
                </p>
              </div>
            </SwiperSlide>
          </Swiper>

          {/* Video 3 */}
        </div>
      </div>
    </div>
  );
}
